<template>
  <el-dialog title="修改记录" :visible.sync="visible" width="700px" :close-on-click-modal="false" @close="handleClose">
    <el-table :data="logList" border v-loading="loading" size="small" max-height="400">
      <el-table-column prop="operTime" label="操作时间" width="160">
        <template slot-scope="scope">
          {{ scope.row.operTime | formatDate }}
        </template>
      </el-table-column>
      <el-table-column prop="operTypeDesc" label="操作类型" width="120"></el-table-column>
      <el-table-column prop="createBy" label="操作人" width="120"></el-table-column>
      <el-table-column prop="operRemark" label="备注" show-overflow-tooltip></el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
export default {
  name: 'NoticeLogDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    noticeId: {
      type: Number,
      default: null
    }
  },
  filters: {
    formatDate(val) {
      if (!val) return '-'
      const d = new Date(val)
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`
    }
  },
  data() {
    return {
      visible: this.value,
      logList: [],
      loading: false
    }
  },
  watch: {
    value(val) {
      this.visible = val
      if (val && this.noticeId) {
        this.getLogs()
      }
    },
    visible(val) {
      this.$emit('input', val)
    },
    noticeId(val) {
      if (this.visible && val) {
        this.getLogs()
      }
    }
  },
  methods: {
    async getLogs() {
      this.loading = true
      try {
        const res = await this.$http.get('/shopNotice/operLogs', {
          params: {
            noticeId: this.noticeId
          }
        })
        if (res.data.status === 0) {
          this.logList = res.data.data.list || []
        } else {
          this.$message.error(res.data.msg || '获取操作日志失败')
        }
      } catch (error) {
        console.error('获取操作日志失败:', error)
        this.$message.error('获取操作日志失败')
      } finally {
        this.loading = false
      }
    },
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

